import React from 'react';
export function Footer() {
  const currentYear = new Date().getFullYear();
  return <footer style={{
    backgroundColor: '#3C3C3C'
  }} className="text-white" aria-label="Site footer" data-id="element-91">
      <div className="max-w-7xl mx-auto px-6 lg:px-8 py-14" data-id="element-92">
        {/* Top Row */}
        <div className="flex flex-col md:flex-row md:items-start md:justify-between gap-8 mb-10 pb-10 border-b border-white/10" data-id="element-93">
          {/* Brand */}
          <div className="max-w-sm" data-id="element-94">
            <div className="flex items-center gap-3 mb-3" data-id="element-95">
              <img src="https://cdn.magicpatterns.com/uploads/wN4KWoun6xQSNGkSCbnNrT/Logo_RR_Group_Consulting_copy.png" alt="RR Group Consulting" className="h-10 w-auto brightness-0 invert" data-id="element-96" />
            </div>
            <p className="text-white font-bold text-lg tracking-wide" data-id="element-97">
              RR GROUP CONSULTING
            </p>
            <p className="text-gray-400 text-sm mt-1" data-id="element-98">
              Rodriguez Rangel Consulting LLC
            </p>
            <p className="text-gray-400 text-sm mt-2 leading-relaxed" data-id="element-99">
              Business Consulting and Technology Consulting Firm
            </p>
          </div>

          {/* Links */}
          <div data-id="element-100">
            <p className="text-white font-semibold text-sm mb-4 uppercase tracking-widest" data-id="element-101">
              Quick Links
            </p>
            <nav aria-label="Footer navigation" data-id="element-102">
              <ul className="space-y-2" data-id="element-103">
                <li data-id="element-104">
                  <a href="#hero" className="text-gray-400 hover:text-white text-sm transition-colors" data-id="element-105">
                    Home
                  </a>
                </li>
                <li data-id="element-106">
                  <a href="#about" className="text-gray-400 hover:text-white text-sm transition-colors" data-id="element-107">
                    About
                  </a>
                </li>
                <li data-id="element-108">
                  <a href="#services" className="text-gray-400 hover:text-white text-sm transition-colors" data-id="element-109">
                    Services
                  </a>
                </li>
                <li data-id="element-110">
                  <a href="#contact" className="text-gray-400 hover:text-white text-sm transition-colors" data-id="element-111">
                    Contact
                  </a>
                </li>
              </ul>
            </nav>
          </div>

          {/* Contact Info */}
          <div data-id="element-112">
            <p className="text-white font-semibold text-sm mb-4 uppercase tracking-widest" data-id="element-113">
              Contact
            </p>
            <div className="space-y-2" data-id="element-114">
              <p className="text-gray-400 text-sm" data-id="element-115">Windermere, Florida 34786</p>
              <p className="text-gray-400 text-sm" data-id="element-116">United States</p>
              <a href="mailto:info@rrgroupconsulting.com" className="block text-gray-400 hover:text-white text-sm transition-colors" data-id="element-117">
                info@rrgroupconsulting.com
              </a>
              <a href="tel:+16892464375" className="block text-gray-400 hover:text-white text-sm transition-colors" data-id="element-118">
                +1 689 246 4375
              </a>
            </div>
          </div>
        </div>

        {/* Legal Disclaimer */}
        <div className="border border-white/10 rounded-xl p-5 mb-8" data-id="element-119">
          <p className="text-gray-400 text-sm leading-relaxed" data-id="element-120">
            <strong className="text-gray-300 font-semibold" data-id="element-121">
              Legal Disclaimer:{' '}
            </strong>
            RR Group Consulting provides business consulting and technology
            consulting services only. We do not provide financial, investment,
            or legal services.
          </p>
        </div>

        {/* Bottom Row */}
        <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4" data-id="element-122">
          <p className="text-gray-500 text-sm" data-id="element-123">
            © {currentYear} Rodriguez Rangel Consulting LLC. All rights
            reserved.
          </p>
          <div className="flex items-center gap-6" data-id="element-124">
            <a href="#" className="text-gray-500 hover:text-gray-300 text-sm transition-colors" data-id="element-125">
              Privacy Policy
            </a>
            <a href="#" className="text-gray-500 hover:text-gray-300 text-sm transition-colors" data-id="element-126">
              Terms of Service
            </a>
            <a href="#contact" className="text-gray-500 hover:text-gray-300 text-sm transition-colors" data-id="element-127">
              Contact
            </a>
          </div>
        </div>
      </div>
    </footer>;
}